import apiClient from './apiClient'
import { API_CONFIG } from './config'
import { delay } from './mockData'

// Fetch user permissions by database name
const getUserPermissions = async (databaseName) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: user permissions for', databaseName)
    return delay([])
  }

  const response = await apiClient.get(`/UserPermissions/database/${databaseName}`)
  return response.data
}

const userPermissionsService = {
  getUserPermissions,
}

export default userPermissionsService
